import BaseService from "@/service/base.service";
import OCTxBean from "@/service/OCTxBean";
import DTODBA21 from "@/service/DTODBA21";
import DTODBA46 from "@/service/DTODBA46";
import router from "../../pages/health/router/index";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

const state = {
  DivNo: "",
  DivName: "",
  DivShortName: "",
  EmpName: "",
  EmpID: "",
  PostionName: "",
  CompID: "",
  Roles: [],
  CathayNo: "",
  isInputData: true,
  fixid: false,
  inputData: {
    id: "",
    cellphone: "",
    sex: "",
    birth_dt: "",
    name: "",
    nicknm: "",
    source: "",
    token_id: "",
    invite_code: "",
    router: "",
    currentSource: "",
    team_invite_code: ""
  },
  ocBeanInputData: {
    id: "",
    cellphone: "",
    sex: "",
    birth_dt: "",
    name: "",
    nicknm: "",
    source: "",
    token_id: "",
    invite_code: "",
    router: "",
    currentSource: "",
    team_invite_code: ""
  },
  loginErrorCode: 0,
  isdoOCSSO: false // true 成功，false 失敗
  //初始=0
  //checkLogin 呼叫：+100  成功：+10  失敗(returncode!=0)：+11
  //doOC_SSO   呼叫：+200  成功：+20  失敗(returncode!=0)：+22
};

const getters = {
  user: state => state,
  inputData: state => state.inputData,
  fixid: state => state.fixid,
  loginErrorCode: state => state.loginErrorCode,
  ocBeanInputData: state => state.ocBeanInputData,
  isdoOCSSO: state => state.isdoOCSSO
};

const actions = {
  login({ commit }, obj) {
    const relayState = window.location.origin + window.location.pathname;

    const samlform = document.createElement("form");
    samlform.action = process.env.VUE_APP_API_HOST + BaseService.samlLogin;
    samlform.method = "POST";

    const relayStateInput = document.createElement("input");
    relayStateInput.type = "hidden";
    relayStateInput.name = "relayState";
    relayStateInput.value = btoa(encodeURIComponent(relayState));

    samlform.appendChild(relayStateInput);
    document.body.appendChild(samlform);
    samlform.submit();
  },
  getUserObject({ commit }, obj) {
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(BaseService.getUserObject, obj).then(resp => {
        if (resp.returnCode === 0) {
          commit("setUser", resp.data);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  },
  isLoggedIn({ commit }, obj) {
    // 處理登入邏輯.
    return new Promise((resolve, rejects) => {
      this._vm.$cathayAxios.get(BaseService.isLoggedIn, obj).then(resp => {
        resolve(resp);
      });
    });
  },
  logout({ commit }, obj) {
    window.location.href = this._vm.$conf.LOGOUT_URL;
  },
  doOCSSO(context, obj) {
    console.log("auth.js doOCSSO");
    const vue = this;
    console.log("auth.js doOCSSO", obj);
    window.doOC_SSO = function (OC_Token) {
      console.log("auth.js doOCSSO", OC_Token);
      context.commit("setErrorCode", 200);
      vue._vm.$OCBean.doOC_SSO(OC_Token).then(resp => {
        console.log("auth.js OCBean", resp);
        if ($.magnificPopup) {
          $.magnificPopup.close();
        }
        if (resp.returnCode === 0) {
          context.commit("setErrorCode", 300);
          vue._vm.$cathayAxios.get(OCTxBean.getOCMember).then(resp2 => {
            console.log("OCTxBean", resp2);
            if (resp2.returnCode === 0) {
              if (!resp2.data.cellPhoneNo) {
                //會員無手機
                router.push({
                  name: "ODBAF230",
                  params: { errorCode: "-1" }
                });
                return;
              }
              context.commit("setInput", resp2.data);
              context.commit("setFixed", $.trim(resp2.data.id).length > 0);
              console.log("resp2", vue.inputData);
              context.commit("setIsDoOCSSO", true);
            }
            context.commit("setIsInputData", false);
            // vue.$refs.odbaf200.IsOClogin = false;
            // vue.doLogin();
          });
        }
        context.commit("setErrorCode", 22);
        return false;
        // vue.doLogin();
      });
    };
  },
  async convertPartyNo(convertType, value) {
    const vue = this;

    const convertResp = await vue._vm.$cathayAxios.post(
      DTODBA21.convertPartyNo,
      {
        convertType,
        value
      }
    );
    if (convertResp.returnCode === 0) {
      const respData = convertResp.data;
      if (respData.returnCode === 0) {
        window.sessionStorage.setItem("firstJoin", false);
        this.partyNo = respData.data;
        const respGuide = await this.$cathayAxios.post(
          DTODBA46.queryPopupCodeRecord,
          { partyNo: this.partyNo, popupCode: "guide" }
        );
        const needGuide = respGuide.returnCode === 0 && respGuide.data == null;
        if (needGuide) {
          this.showF200();
          this.showF200Img = true;
          this.$refs.odbaf200.IsOClogin = false;
        }

        //有無個資同意紀錄
        const respAgree = await this.$cathayAxios.post(DTODBA20.queryByPK, {
          party_no: respData.data,
          agreement_version: this.agreementVersion
        });

        this.agreeRecord = respAgree.data != null;

        if ("MML" === this.inputData.currentSource) {
          this.next(true);
        } else {
          const respBHD = await this.$cathayAxios.post(
            DTODBA22.missingBirthday,
            { party_no: this.partyNo }
          );
          if (respBHD.returnCode === 0) {
            this.birthdayData.need = respBHD.data;
          }
          if (!this.agreeRecord) {
            this.termsStatus.xarefitVerifyData = false;
            this.inputCheck = true;
          }
        }
      } else if (respData.returnCode === -2) {
        this.showF200Img = true;
        this.$refs.odbaf200.IsOClogin = false;
        if ("MML" !== this.inputData.currentSource) {
          this.birthdayData.need = true;
        }
      }
      this.showF200Loading = false;
    }
  }
};

const mutations = {
  setUser(state, obj) {
    if (obj) {
      state.DivNo = obj.divNo;
      state.DivName = obj.divFullName;
      state.DivShortName = obj.divShortName;
      state.EmpName = obj.empName;
      state.EmpID = obj.empID;
      state.PostionName = obj.cepsnnm;
      state.CompID = obj.compID;
      state.Roles = obj.roles;
      state.CathayNo = obj.cathayNo;
    } else {
      state.DivNo = "";
      state.DivName = "";
      state.DivShortName = "";
      state.EmpName = "";
      state.EmpID = "";
      state.PostionName = "";
      state.CompID = "";
      state.Roles = [];
      state.CathayNo = "";
    }
  },
  setOcBeanInputData(state, obj) {
    console.log(obj);
    console.log(state.ocBeanInputData);
    if (obj) {
      state.ocBeanInputData.id = obj.id;
      state.ocBeanInputData.cellphone = obj.cellPhoneNo;
      state.ocBeanInputData.sex = obj.sex;
      state.ocBeanInputData.birth_dt = obj.birthdate;
      state.ocBeanInputData.name = obj.name;
      state.ocBeanInputData.nicknm = obj.name;
      state.ocBeanInputData.source = "MML";
      state.ocBeanInputData.token_id = "";
      state.ocBeanInputData.router = obj.router;
      state.ocBeanInputData.invite_code = obj.invite_code;
      state.ocBeanInputData.currentSource = obj.currentSource;
      state.ocBeanInputData.team_invite_code = obj.team_invite_code;
      console.log(state.ocBeanInputData);
    } else {
      state.ocBeanInputData.id = "";
      state.ocBeanInputData.cellphone = "";
      state.ocBeanInputData.sex = "";
      state.ocBeanInputData.birth_dt = "";
      state.ocBeanInputData.name = "";
      state.ocBeanInputData.nicknm = "";
      state.ocBeanInputData.source = "";
      state.ocBeanInputData.token_id = "";
      state.ocBeanInputData.router = "";
      state.ocBeanInputData.invite_code = "";
      state.ocBeanInputData.currentSource = "";
      state.ocBeanInputData.team_invite_code = "";
    }
  },
  setFixed(state, value) {
    state.fixid = value;
  },
  setErrorCode(state, value) {
    state.loginErrorCode += value;
  },
  setInputData(state, obj) {
    if (obj) {
      state.inputData.id = obj.id;
      state.inputData.cellphone = obj.cellphone;
      state.inputData.sex = obj.sex;
      state.inputData.birth_dt = obj.birth_dt;
      state.inputData.name = obj.name;
      state.inputData.nicknm = obj.name;
      state.inputData.source = obj.source;
      state.inputData.token_id = obj.token_id;
      state.inputData.router = obj.router;
      state.inputData.invite_code = obj.invite_code;
      state.inputData.currentSource = obj.currentSource;
      state.inputData.team_invite_code = obj.team_invite_code;
    } else {
      state.inputData.id = "";
      state.inputData.cellphone = "";
      state.inputData.sex = "";
      state.inputData.birth_dt = "";
      state.inputData.name = "";
      state.inputData.nicknm = "";
      state.inputData.source = "";
      state.inputData.token_id = "";
      state.inputData.router = "";
      state.inputData.invite_code = "";
      state.inputData.currentSource = "";
      state.inputData.team_invite_code = "";
    }
  },
  setIsDoOCSSO(state, value) {
    state.isdoOCSSO = value;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
